import styles from './ListBox.module.scss';
import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useListState } from 'react-stately';
import { mergeProps, useListBox, useVisuallyHidden } from 'react-aria';
import ListBoxItem from 'client/pages/MapPage/components/MapMenu/ListBox/ListBoxItem/ListBoxItem';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

const ListBox = props => {
    const defaultState = useListState(props);
    const state = props.state ? props.state : defaultState;
    const { visuallyHiddenProps } = useVisuallyHidden();

    const ref = useRef();
    const { labelProps, listBoxProps } = useListBox(props, state, ref);

    return (
        <>
            <div {...mergeProps(visuallyHiddenProps, labelProps)}>
                {props?.label}
            </div>
            <ul
                {...listBoxProps}
                ref={ref}
                className={[styles.container, props.className].join(' ')}
            >
                {[...state.collection].map((item) =>
                    <ListBoxItem key={item.key} item={item} state={state}/>
                )}
            </ul>
        </>
    );
};

ListBox.propTypes = {
    ...defaultAriaProps,
    selectionMode: PropTypes.oneOf(['single', 'multiple'])
};

export default ListBox;
